import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CourseContent from "./components/CourseContent";
function Courses(){
    return (
        <div>
            <Header/>
            <CourseContent/>
            <Footer/>
        </div>
    )
}
export default Courses;